import { render, staticRenderFns } from "./CurrentUserAvatar.vue?vue&type=template&id=75e8f873"
import script from "./CurrentUserAvatar.vue?vue&type=script&lang=js"
export * from "./CurrentUserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports